var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 53,
    viewBox: "0 0 58 53",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9375 0.5V53H57.4375V0.5H39.9375ZM44.3125 4.875H53.0625V48.625H44.3125V4.875ZM0.5625 13.625V53H18.0625V13.625H0.5625ZM4.9375 18H13.6875V48.625H4.9375V18ZM20.25 26.75V53H37.75V26.75H20.25ZM24.625 31.125H33.375V48.625H24.625V31.125Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.4e7425d2e4f9831cd1b29331689cbb09.svg";
export { ForwardRef as ReactComponent };